import { serviceClient, utils } from '@yola/ws-sdk';

const POLLING_INTERVAL = 500;

const initiateTextReplacement = async (params, abortController = {}) => {
  const client = serviceClient.get();
  const response = await client.initiateTextReplacement(params, { abortController });
  const {
    data: { id: jobId },
  } = response;

  return utils.pollAsyncJob({
    jobId,
    interval: POLLING_INTERVAL,
    abortSignal: abortController.signal,
  });
};

export default initiateTextReplacement;
